import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { SITE } from "@/lib/site";
import { FAQS } from "@/lib/faq-data";


export const Route = createFileRoute("/faq")({
  head: () => ({
    meta: [
      { title: `Preguntas frecuentes — ${SITE.brand.name}` },
      { name: "description", content: "Cancelaciones, pagos, descuentos y todo lo que necesitas saber antes de reservar." },
      { property: "og:title", content: `Preguntas frecuentes — ${SITE.brand.name}` },
      { property: "og:url", content: "/faq" },
    ],
    links: [{ rel: "canonical", href: "https://www.mostrandomexico.mx/faq" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FAQS.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
    ],
  }),
  component: FaqPage,
});

function FaqPage() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <header className="mb-10 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">Ayuda</p>
          <h1 className="mt-3 font-display text-4xl font-semibold sm:text-5xl">
            Preguntas frecuentes
          </h1>
        </header>
        <div className="space-y-3">
          {FAQS.map((f) => (
            <details
              key={f.q}
              className="group rounded-2xl border border-border bg-card p-5 shadow-card open:border-primary/40"
            >
              <summary className="cursor-pointer list-none font-semibold text-foreground">
                {f.q}
              </summary>
              <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{f.a}</p>
            </details>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
